import DialPadLogo from '@/assets/images/dialpad.png';

const DialPadIcon = () => (
    <img
        src={DialPadLogo}
        alt="Dial Pad Logo"
        style={{ height: 25, width: 25, borderRadius: '50%' }}
    />
);

export default DialPadIcon;
